// extracted by mini-css-extract-plugin
export default {"alert":"SearchAssistModal_alert__gz01x","assistModal":"SearchAssistModal_assistModal__TrpZI"};